import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { backendApi, getGoogleUserInfo } from '../components/Api';
import { useNavigate } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Arrow from '../assets/images/white-arrow.png';

const serverUrl = process.env.REACT_APP_SERVER_URL;

// Read-only Analytics access. Google Identity Services also grants
// "openid profile email" on top of this, which is what lets us read the
// signed-in user's name/email from the userinfo endpoint below.
const ANALYTICS_SCOPE = 'https://www.googleapis.com/auth/analytics.readonly';

const Login = ({ endIcon }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const onSuccess = async (tokenResponse) => {
    const accessToken = tokenResponse?.access_token;
    if (!accessToken) {
      navigate('/', { state: { error: { error: 'no_access_token' } } });
      return;
    }

    setBusy(true);

    // The implicit flow returns a token only, so the profile is fetched separately.
    const profile = await getGoogleUserInfo(accessToken);
    if (!profile?.email) {
      setBusy(false);
      navigate('/', { state: { error: { error: 'profile_unavailable' } } });
      return;
    }

    const expiresIn = tokenResponse?.expires_in ? Number(tokenResponse.expires_in) : 3480;
    const body = {
      email: profile.email,
      firstname: profile.given_name,
      lastname: profile.family_name,
      expire_time: Math.round(new Date().getTime() / 1000) + expiresIn,
      access_token: accessToken,
    };

    const response = await backendApi(`${serverUrl}api/auth/signin`, body);
    setBusy(false);

    // backendApi resolves with the axios error object when the request fails,
    // so anything without a `data` payload is a failed sign-in.
    if (!response?.data) {
      const error = response?.message || 'Sign in failed';
      navigate('/', { state: { error } });
      return;
    }

    const userDetails = response.data;
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('userDetails', JSON.stringify(userDetails));
    localStorage.setItem('expire_at', userDetails?.expire_at);

    navigate('/', {
      state: {
        userDetails,
        isAccount: true,
        accessToken,
        expire_at: userDetails?.expire_at,
      },
    });
  };

  const onError = (error) => {
    setBusy(false);
    navigate('/', { state: { error } });
    console.log('failed:', error);
  };

  const signIn = useGoogleLogin({
    flow: 'implicit',
    scope: ANALYTICS_SCOPE,
    prompt: 'consent select_account',
    onSuccess,
    onError,
    onNonOAuthError: onError,
  });

  return (
    <Button className='theme-btn' onClick={() => signIn()} disabled={busy} size="small">
      Check My Analytics
      {endIcon ? (
        <Box
          component={'img'}
          src={Arrow}
          marginLeft={1}
          width={25}
        />
      ) : ''}
    </Button>
  );
};

export default Login;
